import {
	Alert,
	Box,
	Button,
	Grid,
	IconButton,
	Input,
	InputAdornment,
	InputLabel,
	OutlinedInput,
	Snackbar,
	TextField,
	Typography,
} from '@mui/material';
import manageProfileIcon from '../../../../assets/logos/manageProfileicon.png';
import { useNavigate, Link } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import React, { useEffect, useState } from 'react';

import { styled } from '@mui/system';
import {
	getUser,
	resendCode,
	updateUser,
} from '../../../services/api/apiManager';
import { logoutFunc } from '../../../layouts/sidebar/SideBar';

import * as Yup from 'yup';
import { Call, Visibility, VisibilityOff } from '@mui/icons-material';
import MaskedInput from 'react-text-mask';

const StyledFileInput = styled('input')({
	display: 'none', // Hide the input visually
});

const StyledTypography = styled(Typography)({
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: '300',
	color: '#726A6A',
	textDecoration: 'underline',
	cursor: 'pointer',
});
function ManageProfile() {
	const defaultTheme = createTheme();
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [emptyField, setEmptyFieldError] = useState(false);
	const [wrongCurrentPassword, setwrongCurrentPassword] = useState(false);
	const [showPassword, setShowPassword] = React.useState(false);
	const [errors, setErrors] = useState({});
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};
	console.log(`errors`, errors);
	const schema = Yup.object().shape({
		fname: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		lname: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		email: Yup.string().email('Invalid E-mail').required('Required*'),
		contact: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Incomplete '
		),
	});

	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbar(false);
	};
	const handleSnackbaErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
	};

	const navigate = useNavigate();
	const [fname, setFname] = useState('');
	const [lname, setLname] = useState('');
	const [contact, setContact] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [password2, setPassword2] = useState('');
	const [flag, setflag] = useState(false);
	const [flag1, setflag1] = useState(false);
	const [flag2, setflag2] = useState(true);

	console.log(flag);
	const handleInputChange = (e) => {
		debugger;
		const { name, value } = e.target;
		if (name == 'fname') {
			setFname(value);
			setflag2(false);
		} else if (name == 'lname') {
			setflag2(false);
			setLname(value);
		} else if (name == 'contact') {
			setflag2(false);
			setContact(value);
		} else if (name == 'email') {
			setflag(true);
			setflag2(false);
			setEmail(value);
		}

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};
	const fetchuser = async () => {
		try {
			const response = await getUser();
			if (response?.status === 200) {
				const u = response?.data[0];
				// setUser(response?.data[0]);
				setFname(u?.first_name);
				setLname(u?.last_name);
				setEmail(u?.email);
				setContact(u.UserContactNo);
			} else {
				setFname('');
				setLname('');
				setEmail('');
				setContact('');
			}
		} catch (error) {
			console.error('Error fetching user:', error);
		}
	};
	const updateUserData = async () => {
		debugger;
		try {
			var user = {};
			if (flag1) {
				user = {
					email: email,
					password: password,
					password2: password2,
				};
			} else if (flag && flag1) {
				user = {
					email: email,
					first_name: fname,
					last_name: lname,
					UserContactNo: contact,
					password: password,
					password2: password2,
				};
			} else if (flag && !flag1) {
				user = {
					email: email,
					first_name: fname,
					last_name: lname,
					UserContactNo: contact,
				};
			} else {
				user = {
					first_name: fname,
					last_name: lname,
					UserContactNo: contact,
				};
			}
			const response = await updateUser(user);
			if (response?.status === 200) {
				const u = response?.data;
				setFname(u?.first_name);
				setLname(u?.last_name);
				setEmail(u?.email);
				setContact(u?.UserContactNo);
				localStorage.removeItem('userName');
				localStorage.setItem('userName', u?.last_name + ',' + u?.first_name);
				if (!flag && !flag1) {
					window.location.reload();
				}
				// setPayer(true);
				setOpenSnackbar(true);
				if (flag) {
					const data = { email: email };
					const res = await resendCode(data);
					if (res?.status === 201) {
						logoutFunc();
						navigate('/verification');
					}
				}
				if (flag1) {
					logoutFunc();
					navigate('/');
				}
				// setPayer(response?.data);
			} else if (
				response?.response?.data?.non_field_errors[0] ==
				'Invalid credentials, Try Again Please'
			) {
				setwrongCurrentPassword(true);
			} else {
				setOpenSnackbarError(true);
			}
		} catch (error) {
			setOpenSnackbarError(true);
		}
	};
	useEffect(() => {
		fetchuser();
	}, []);
	const [selectedPicture, setSelectedPicture] = useState(null);

	const handleFileInputChange = (event) => {
		const file = event.target.files[0];
		const reader = new FileReader();
		reader.onload = () => {
			setSelectedPicture(reader.result);
		};
		reader.readAsDataURL(file);
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Box
				sx={{
					width: '100%',
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					padding: '5px',
				}}
			>
				<Typography
					width={'50%'}
					height={'27px'}
					mt={1}
					ml={1}
					sx={{
						fontFamily: 'Poppins',
						fontSize: '18px',
						fontWeight: 600,
						color: '#075AD7',
					}}
				>
					ACCOUNT
				</Typography>
			</Box>

			<Grid container>
				<Grid
					item
					xs={12}
					sm={12}
					md={12}
					lg={12}
					xl={12}
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'column',
						border: '1px solid #0000003D',
						borderRadius: '8px',
						backgroundColor: '#FFFFFF',
						height: '220px',
					}}
				>
					<Grid container justifyContent={'space-evenly'} height={'220px'}>
						<Grid
							item
							xs={12}
							sm={12}
							md={2}
							lg={2}
							xl={2}
							display={'flex'}
							flexDirection={'column'}
							justifyContent={'center'}
							alignItems={'center'}
						>
							<Box component={'img'} src={manageProfileIcon}></Box>
							<Typography
								variant="body1"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '18px',
									fontWeight: '600',
								}}
							>
								Account
							</Typography>
							{/* <input
								style={{ display: 'none' }}
								type="file"
								id="fileUpload"
								name="uploadPic"
								accept="image/*"
							/>
							<label
								htmlFor="fileUpload"
								style={{
									cursor: 'pointer',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 400,
									textDecoration: 'underline',
									color: '#726A6A',
								}}
							>
								Update Picture
							</label> */}
						</Grid>

						<Grid
							item
							xs={12}
							sm={12}
							md={4}
							lg={4}
							xl={4}
							sx={{
								padding: '5px',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-evenly',
							}}
						>
							<Box>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									First Name
								</InputLabel>
								<OutlinedInput
									size="small"
									type="text"
									fullWidth
									value={fname}
									// onChange={(e) =>
									// 	setFname(e.target.value)
									// }
									onChange={handleInputChange}
									name="fname"
									disableUnderline
									sx={{
										// border: '1px solid #00000026',
										borderRadius: '4px',
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									}}
									error={errors.fname}
								/>
								{errors.fname && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.fname}
									</div>
								)}{' '}
							</Box>

							{/* Display validation error */}
							<Box>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Contact # <span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<MaskedInput
									required
									name="contact"
									value={contact}
									onChange={handleInputChange}
									mask={[
										'(',
										/\d/,
										/\d/,
										/\d/,
										')',
										' ',
										/\d/,
										/\d/,
										/\d/,
										'-',
										/\d/,
										/\d/,
										/\d/,
										/\d/,
									]}
									style={{
										width: '100%',
										borderRadius: '6px',
										height: '40px',
										marginBottom: '8px',
										// marginTop: '8px',
										border: `${
											errors.contact
												? '1.5px solid #d61b1b'
												: '1.5px solid #DDE6F1'
										}`,
										padding: '5px 0px 5px 6px',

										outlineColor: '#f3a765',
										boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
									}}
								/>
								{errors.contact && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.contact}
									</div>
								)}{' '}
								{/* Display validation error */}
							</Box>
						</Grid>
						<Grid
							item
							lg={4}
							md={4}
							xl={4}
							sm={12}
							xs={12}
							sx={{
								padding: '5px',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-evenly',
							}}
						>
							<Box>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Last Name
								</InputLabel>
								<OutlinedInput
									type="text"
									size="small"
									fullWidth
									disableUnderline
									value={lname}
									onChange={handleInputChange}
									name="lname"
									sx={{
										borderRadius: '4px',
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									}}
									error={errors.lname}
								/>
								{errors.lname && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.lname}
									</div>
								)}{' '}
							</Box>

							{/* Display validation error */}
							<Box>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Email<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<OutlinedInput
									name="email"
									type="email"
									fullWidth
									disableUnderline
									disabled
									size="small"
									inputProps={{
										autoComplete: '',
									}}
									value={email}
									onChange={(e) => {
										// setEmail(e.target.value);
										// setflag(true);
										handleInputChange(e);
									}}
									sx={{
										// border: '1px solid #00000026',
										borderRadius: '4px',
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									}}
									error={errors.email}
								/>
								{errors.email && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.email}
									</div>
								)}{' '}
							</Box>
						</Grid>
					</Grid>
				</Grid>
			</Grid>

			<Box
				sx={{
					width: '100%',
					display: 'flex',
					justifyContent: 'flex-start',
					alignItems: 'center',
					mt: { xs: 20, sm: 20, md: 0, lg: 0, xl: 0 },
				}}
			>
				<Typography
					width={'50%'}
					height={'27px'}
					mt={1}
					ml={1}
					sx={{
						fontFamily: 'Poppins',
						fontSize: '18px',
						fontWeight: 600,
						color: '#075AD7',
					}}
				>
					SECURITY
				</Typography>
			</Box>
			<Grid
				container
				xs={12}
				sm={12}
				md={12}
				lg={12}
				xl={12}
				sx={{
					border: '1px solid #0000003D',
					borderRadius: '8px',
					backgroundColor: '#FFFFFF',
					height: '154px',
				}}
			>
				<Grid item xs={2.8} sm={2.8} md={2.8} lg={2.8} xl={2.8}></Grid>
				<Grid
					container
					item
					xs={8.7}
					sm={8.7}
					md={8.7}
					lg={8.7}
					xl={8.7}
					alignItems={'center'}
					justifyContent={'space-around'}
				>
					<Grid
						item
						lg={5.5}
						md={5.5}
						xl={5.5}
						sm={12}
						xs={12}
						sx={{ padding: '5px' }}
					>
						<Typography
							variant="body2"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: '500',
								textAlign: 'left',
								color: 'black',
							}}
						>
							Current Password
						</Typography>
						<OutlinedInput
							fullWidth
							required
							size="small"
							id="password"
							inputProps={{
								autoComplete: 'new-password',
							}}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							sx={{
								border: '1px solid #00000026',
								borderRadius: '4px',
								boxShadow: '0px 1px 10px 0px #79ACF178 inset',
							}}
							type={showPassword ? 'text' : 'password'}
							endAdornment={
								<InputAdornment position="end">
									<IconButton
										aria-label="toggle password visibility"
										onClick={handleClickShowPassword}
										onMouseDown={handleMouseDownPassword}
										edge="end"
										sx={{ color: '#DDE6F1' }}
									>
										{showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</InputAdornment>
							}
						/>
					</Grid>
					<Grid
						item
						lg={5.5}
						md={5.5}
						xl={5.5}
						sm={12}
						xs={12}
						sx={{ padding: '5px' }}
					>
						<Typography
							variant="body2"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: '500',
								textAlign: 'left',
								color: 'black',
							}}
						>
							Change Password
						</Typography>
						<OutlinedInput
							fullWidth
							required
							size="small"
							value={password2}
							onChange={(e) => {
								setPassword2(e.target.value);
								setflag1(true);
							}}
							sx={{
								border: '1px solid #00000026',
								borderRadius: '4px',
								boxShadow: '0px 1px 10px 0px #79ACF178 inset',
							}}
							type={showPassword ? 'text' : 'password'}
							endAdornment={
								<InputAdornment position="end">
									<IconButton
										aria-label="toggle password visibility"
										onClick={handleClickShowPassword}
										onMouseDown={handleMouseDownPassword}
										edge="end"
										sx={{ color: '#DDE6F1' }}
									>
										{showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</InputAdornment>
							}
						/>
					</Grid>
				</Grid>
			</Grid>

			<Box width={'100%'} display={'flex'} justifyContent={'flex-end'} mt={2}>
				<Button
					disabled={
						errors.email ||
						errors.fname ||
						errors.lname ||
						errors.contact ||
						flag2
					}
					sx={{
						backgroundColor: `${errors.email || errors.fname || errors.lname || errors.contact ? 'grey' : '#00A2E8'}`,
						color: 'white',
						fontFamily: 'Poppins',
						fontSize: '15px',
						fontWeight: '500',
						padding: '7px 15px',
						'&:hover': {
							background: '#00A2E8',
						},
					}}
					onClick={() => updateUserData()}
				>
					Update
				</Button>
			</Box>

			{/* snack bar for Patient added successfully */}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={6000} // Adjust the duration as needed
				onClose={handleSnackbarClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbarClose}
					severity="success"
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					Updated Successfully
				</Alert>
			</Snackbar>
			{/* snack bar for 401 error  */}
			<Snackbar
				open={openSnackbarError}
				autoHideDuration={6000} // Adjust the duration as needed
				onClose={handleSnackbaErrorClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbaErrorClose}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '17px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					Error
				</Alert>
			</Snackbar>
			{/* snack bar for Wrong Current password */}
			<Snackbar
				open={wrongCurrentPassword}
				autoHideDuration={2000} // Adjust the duration as needed
				onClose={handleSnackbaErrorClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbaErrorClose}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '15px',
						fontWeight: '400',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					Invalid crenditials, Try Again Please
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default ManageProfile;
